<template>
  <div>
    <FilterItems :datasIn="highwayTollboth" @filtered="updatedDatas"></FilterItems>

    <catalog-table
      :propsToSearch="propsToSearch"
      :tableData="newDatas"
      :tableHeaders="obb"
      :actions="customerActions"
      :tableFilters="customerFilters"
      :pageSize="25"
    >
      <template v-if="$can('add', 'Highway', 'tollbooth')" slot="search-toolbar-actions">
        <md-button class="md-success" @click="prepareCreate">
          <span class="md-label">
            <md-icon class="material-icons">add</md-icon>
          </span>
          Agregar
        </md-button>
      </template>
    </catalog-table>

    <editModal
      v-if="classicModal"
      :editedItem="item"
      @close="classicModalHide"
      @saved="updateElement"
      @error="classicModalHide"
    >
      <template slot="header">
        <h4 v-if="isRegister" class="modal-title">Agregar caseta</h4>
        <h4 v-else class="modal-title">Editar caseta</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="classicModalHide"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
    </editModal>
  </div>
</template>

<script>
import { CatalogTable } from "@/components";
import dataService from "../../../services/catalog";
import { booleanToState } from "@/filters";
import editModal from "./editModal";
import FilterItems from "./Filter";

export default {
  components: {
    CatalogTable,
    editModal,
    FilterItems,
  },
  data() {
    return {
      highwayTollboth: [],
      newDatas: [],
      // company
      item: {},

      // table props
      propsToSearch: [
        "name",
        "highwayName",
        "highwaySectionName",
        "tollboothAttendantName",
      ],
      obb: {
        name: "Nombre Caseta",
        highwayName: "Carretera",
        highwaySectionName: "Tramo Carretero",
        municipalityName: "Municipio",
        stateName: "Estado",
        tollboothAttendantName: "Coordinador electromecánico",
      },
      customerFilters: {
        isActive: booleanToState,
      },

      customerActions: [
        {
          icon: "edit",
          exe: this.prepareEdit,
          showIf: () => this.$can("change", "Highway", "tollbooth"),
        },
        {
          icon: "delete",
          exe: this.deleteItem,
          showIf: () => this.$can("delete", "Highway", "tollbooth"),
        },
      ],
      // Modal
      classicModal: false,
      isRegister: false,

      clientReady: false,
      municipalityReady: false,
    };
  },
  methods: {
    updatedDatas(datas) {
      this.newDatas = datas;
    },
    // Modal
    classicModalHide() {
      this.classicModal = false;
    },

    prepareEdit(c) {
      // get element selected from table
      this.item = c; // make copy of element selected
      this.isRegister = false; // Modal in mode edition
      this.classicModal = true; // show modal
    },

    prepareCreate() {
      this.isRegister = true;
      this.item = {};
      this.classicModal = true;
    },

    updateElement({ original, updated }) {
      // excecute when the form is valid
      this.classicModalHide();
      if (!original.id) {
        this.createdE(updated);
      } else {
        this.editElement(updated, original);
      }
    },

    // CRUD Services
    createdE(h) {
      dataService
        .create("highway/tollbooth", h, { source: this.highwayTollboth })
        .then((highwaycompany) =>
          this.$successMessage({
            title: `Se creo: ${highwaycompany.name} con Exito`,
          })
        )
        .catch(this.$fireErrorResponse);
    },

    editElement(updated, original) {
      dataService
        .update("highway/tollbooth", updated, original, {
          source: this.highwayTollboth,
        })
        .then(
          (h) => this.$successMessage({ title: `${h.name} fue Editado` }),
          this.$fireErrorResponse
        );
    },

    consultElement() {
      dataService
        .fetch("highway/tollbooth")
        .then((highwayTollboth) => (this.highwayTollboth = highwayTollboth))
        .catch(this.$fireErrorResponse);
    },

    deleteItem(c) {
      this.$confirmMessage({ title: "¿Estas seguro?" }, () => {
        return dataService
          .delete("highway/tollbooth", c, { source: this.highwayTollboth })
          .then(() => this.$successMessage({ title: "Borrado" }))
          .catch(this.$fireErrorResponse);
      });
    },
  },
  mounted() {
    this.consultElement("highway/tollbooth");
    // this.consultMetas('highway/gethighway/','mHighway')
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/Catalogs/HighwayTollbooth/index.vue